import { IAffiliateCrudModalLang } from '../../../types/lang'

export const affiliateCrudModalLang: IAffiliateCrudModalLang = {
	affiliate_crud_modal: {
		title_edit: 'Edit affiliate_ru',
		title_notes_view: 'View notes for affiliate_ru',
		title_notes_edit: 'Edit notes for affiliate_ru',
		field_name_label: 'Name_ru',
		field_name_placeholder: 'Name_ru',
		field_date_label: 'Date_ru',
		field_date_placeholder: 'Date_ru',
		field_percent_label: 'Percent, %_ru',
		field_percent_placeholder: 'Percent, %_ru',
		field_notes_label: 'Notes_ru',
		field_notes_placeholder: 'Notes_ru',
		btn_add_record: 'Add Record_ru',
		btn_update: 'Save_ru',
		btn_close: 'Close_ru'
	}
}